import { request } from '../../utils'
import { getChat } from '../../../Chat/blocs/chatVisibility'

export const fetchComments = (
  liveId,
  commentType,
  chatRoom,
  options = {},
  page = 1
) => {
  const url = '/api/comment/list'
  let messageType = commentType
  if (messageType === 'chat') {
    messageType = getChat(chatRoom).messageType
  }

  return request({
    url,
    method: 'GET',
    data: {
      object_id: liveId,
      comment_type: messageType,
      p: page,
      size: options.size || 40,
      presenter_token: options.presenterToken,
      order: options.order,
    },
  })
}

export const fetchComment = (commentId, liveId, presenterToken) => {
  const url = '/api/comment/list'

  return request({
    url,
    method: 'GET',
    data: {
      object_id: liveId,
      comment_id: commentId,
      presenter_token: presenterToken,
    },
  })
}

export const getLiveRealtimeData = (liveId) => {
  const url = '/api/comment/list'

  return request({
    url,
    method: 'GET',
    data: {
      object_id: liveId,
      include_realtime_p: 1,
      size: 0,
    },
  })
}

export const addComment = (
  liveId,
  token,
  content,
  commentType,
  chatRoom,
  userInfo = {}
) => {
  const url = '/api/comment/add'
  let messageType = commentType
  if (messageType === 'chat') {
    messageType = getChat(chatRoom).messageType
  }

  return request({
    url,
    data: {
      object_id: liveId,
      object_token: token,
      content,
      object_type: 'live',
      comment_type: messageType,
      name: userInfo.name,
      uuid: userInfo.uuid,
    },
  })
}

export const deleteComment = (liveId, commentId) => {
  const url = '/api/comment/delete'

  return request({
    url,
    data: {
      live_id: liveId,
      comment_id: commentId,
    },
  })
}

export const updateComment = (liveId, commentId, status) => {
  const url = '/api/2/comment/update'

  return request({
    url,
    data: {
      object_id: liveId,
      comment_id: commentId,
      comment_status: status,
    },
  })
}

export const postCommentSetOrder = (liveId, comments) => {
  const url = '/api/2/comment/set-order'
  const order = comments.map((comment) => comment.comment_id).join(',')

  return request({
    url,
    data: {
      object_id: liveId,
      order,
    },
  })
}
